import { API_ROOT } from 'config/index';
import { AUTH_API } from 'middleware/api';
import withOptions from 'utils/functions/withOptions.util';
import actionType from 'utils/mw/actionType.util';

const ATAG = 'beGetSalonPastBookings';
const AT = actionType(ATAG);

const beGetSalonPastBookings = withOptions(({ bookingsSalonId, cognitoUserName, page = 1 }) => ({
  [AUTH_API]: {
    apiRoot: API_ROOT,
    endpoint: `ncob/client/appointments/${bookingsSalonId}/past/${cognitoUserName}/?page=${page}`,
    authenticated: true,
    types: [AT.init, AT.pass, AT.fail, AT.done],
    config: {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
  },
}));

beGetSalonPastBookings.ATAG = ATAG;
beGetSalonPastBookings.AT = AT;

export default beGetSalonPastBookings;
